<template>
    <path fill-rule="evenodd" d="M12.158.841C11.038-.28 9.219-.28 8.1.841L.66 8.28c-.058.058-.094.132-.105.213l-.551 4.083c-.017.116.025.232.105.313.07.069.166.11.263.11.017 0 .033 0 .05-.002l2.46-.333c.205-.027.349-.216.32-.42-.027-.206-.215-.35-.42-.322l-1.972.266.385-2.848 2.997 2.997c.069.07.166.111.263.111s.194-.039.263-.11l7.44-7.438C12.7 4.356 13 3.636 13 2.87c0-.767-.3-1.488-.842-2.028zm-3.914.914l1.25 1.25-6.79 6.789-1.249-1.25 6.79-6.789zm-3.786 9.79l-1.222-1.222 6.79-6.79 1.22 1.222-6.788 6.79zm7.31-7.324l-2.99-2.99c.38-.312.854-.484 1.352-.484.568 0 1.1.222 1.502.62.401.4.62.934.62 1.502 0 .501-.172.972-.485 1.352z"/>
</template>

<script>
export default {
    name: 'editIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 13 13');
    }
};
</script>
